import PanelBar from "../core/components/panelBar.js";
import { SkillEditBox, SkillEditBoxProps } from "../core/components/skills/skillEditBox.js";
import { GridCustomToolBarButton, ToolBar, ToolBarCustomButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Helper } from "../core/util/helper.js";
import { Skill, TreeNodeVm } from "../generalSettings/skills/skillsInterfaces.js";
import React from "react";

export default class Skills extends React.Component<{
    getSkillNodesRecursive: (treeNode: TreeNodeVm) => TreeNodeVm[];
    selectedNode: TreeNodeVm;
    columnCount: number;
    useTargetValues: boolean;
    usePriority: boolean;
    skillEditBoxProps: SkillEditBoxProps;
    onSkillEditBoxChange: (skill: Skill, value, field) => void;
    standardButtons?: Array<ToolBarStandardButton>;
    customButtons?: Array<GridCustomToolBarButton>;
    onClickStandardButton?(type: any);
    onClickCustomButton?(id: string, dataItem: any, allItems?: Array<any>);
}, any>{
    private getSkillsNodes(node: TreeNodeVm) {
        let skillNodes: TreeNodeVm[] = [];

        if (!node)
            return skillNodes;

        if (node.IsSkill)
            skillNodes.push(node)
        else
            skillNodes.push(...this.props.getSkillNodesRecursive(node));

        return skillNodes;
    }

    private getSkillEditBoxes() {
        let skillNodes = this.getSkillsNodes(this.props.selectedNode);
        let showDefaultTag = skillNodes.length == 0;
        let skills = showDefaultTag ? (this.createDefaultTag(Helper.getTranslation("Skills.NoSkillsExist"))) :
        skillNodes.map((treeNode, idx) => {
            return this.getSkillEditBox(treeNode);
        });
        return skills;
    }

    private getSkillEditBox(treeNode: TreeNodeVm) {
        let props = this.props.skillEditBoxProps;
        return (
            <SkillEditBox
                {...props}
                skill={treeNode.Item}
                treeNode={treeNode}
                onChange={this.props.onSkillEditBoxChange}
                useTargetValues={this.props.useTargetValues}
                usePriority={this.props.usePriority}
                // AP key muss eindeutig sein, idx-Wert war nur aktueller Index in Skills-Liste
                // deshalb wurde immer das falsche Element gerendert sobald die Skills-Liste sich ändert
                key={treeNode.Item.Fid + "_" + treeNode.Item.Rindex} />
        )
    }

    private createDefaultTag = (text: string) => {
        const styleIcon: React.CSSProperties = {
            textAlign: "center",
            color: "#eaeaea",
            marginTop: "10px"
        }

        return (
            <div style={{ width: "240px" }}>
                <div style={{ lineHeight: "130%" }}>{text}</div>
                <div style={styleIcon}><i className="fal fa-times-circle fa-10x" style={{}}></i></div>
            </div>
        );
    }

    private getDescription = () => {
        if (!Helper.hasValue(this.props.selectedNode)
            || this.props.selectedNode.IsSkill
            || !Helper.hasValue(this.props.selectedNode.Item.FMemo))
            return null;

        return <PanelBar headerText={Helper.getTranslation("Regionen.Projekt.Beschreibung")}>
            <label style={{ whiteSpace: "pre-wrap" }}>{this.props.selectedNode.Item.FMemo}</label>
        </PanelBar>
    }

    private _handleStandardButtonClick = (type: ToolBarStandardButtonType) => {
        if (this.props.onClickStandardButton) {
            this.props.onClickStandardButton(type);
        }
    }

    private _handleCustomButtonClick = (id: string) => {
        if (this.props.onClickCustomButton) {
            this.props.onClickCustomButton(id, this.props.selectedNode);
        }
    }

    render() {
        if (!Helper.hasValue(this.props.selectedNode))
            return null;

        const stdBtn: Array<ToolBarStandardButton> = [], cusBtn: Array<ToolBarCustomButton> = [];

        if (Array.isArray(this.props.standardButtons)) {
            for (let i = 0; i < this.props.standardButtons.length; i++) {
                const btn = this.props.standardButtons[i];
                stdBtn.push({
                    caption: btn.caption,
                    enabled: btn.enabled && (btn.type === ToolBarStandardButtonType.EDIT || btn.type === ToolBarStandardButtonType.DELETE ? this.props.selectedNode !== null : true),
                    type: btn.type
                });
            }
        }

        if (Array.isArray(this.props.customButtons)) {
            for (let i = 0; i < this.props.customButtons.length; i++) {
                const btn = this.props.customButtons[i];
                cusBtn.push({
                    caption: btn.caption,
                    enabled: btn.enabled && (!btn.autoEnabledOnRecordSelected || this.props.selectedNode !== null),
                    iconClass: btn.iconClass,
                    id: btn.id,
                    width: btn.width
                });
            }
        }

        let skills = this.getSkillEditBoxes();
        let description = this.getDescription();
        return (<div className="skills flex-container__item">
            <ToolBar standardButtons={stdBtn} customButtons={cusBtn} handleStandardButtonClick={this._handleStandardButtonClick} handleCustomButtonClick={this._handleCustomButtonClick} />
            {description}
            <div style={{ display: "grid", gridTemplateColumns: `minmax(auto, calc(100% - 180px)) repeat(${this.props.columnCount - 1}, minmax(auto, 180px))`, rowGap: "5px", columnGap: "5px" }}>
                <div className="skills-grid__header">{Helper.getTranslation("Regionen.Projekt.Beschreibung")}</div>
                <div className="skills-grid__header">{Helper.getTranslation("Einsatz.Actual")}</div>
                {this.props.useTargetValues ? <div className="skills-grid__header">{Helper.getTranslation("Field.Einsatz.soll")}</div> : null}
                {this.props.useTargetValues ? <div className="skills-grid__header">{Helper.getTranslation("Skills.TargetDate")}</div> : null}
                {this.props.usePriority ? <div className="skills-grid__header">{Helper.getTranslation("Standard.Priority")}</div> : null}
                {skills}
            </div>
        </div>);
    }
}